import { useNavigate } from 'react-router-dom'
import {
  Accordion,
  Button,
  Card,
  Image,
  Link,
  Text,
  CardColors,
  Separator,
} from '@/ui'
import { TypographyStyles } from '@/styles'
import { PlaidLink } from '@/components/plaid/PlaidLink'

export const IncompleteAccount = () => {
  const navigate = useNavigate()

  const handleClick = () => {
    navigate('/dashboard')
  }

  return (
    <div className="flex flex-col gap-12 w-full max-w-2xl mx-auto mb-8 px-4">
      <Text variant={TypographyStyles.H2}>
        Your Heard account is incomplete
      </Text>

      <Card color={CardColors.PRIORITY}>
        <div className="flex flex-col items-center gap-6">
          <Image
            src="https://heard-images.s3.amazonaws.com/assets/pavilion_exclamation_mark.png"
            alt="Exclamation mark"
            className="w-20 h-20"
          />

          <div className="text-left space-y-4">
            <Text>
              You’ve indicated that your account(s) could not be connected with
              Plaid. We’ll follow up with you via Messages.
            </Text>
            <Text>
              In the meantime, we recommend replacing them with accounts at
              compatible banks. A compatible bank allows Heard to provide you
              the most consistent service.
            </Text>
          </div>

          <PlaidLink buttonVariant="primary" redirect={false} />

          <Separator />

          <div className="w-full space-y-6">
            <Accordion type="single" collapsible variant="text">
              <Accordion.Item value="business-bank">
                <Accordion.Trigger>
                  Where can I open a business checking account?
                </Accordion.Trigger>
                <Accordion.Content>
                  <Text variant={TypographyStyles.BODY_SM}>
                    You can open a business checking account with any bank or
                    provider, then come back when you&apos;re ready. We
                    recommend going with a larger institution. They&apos;re more
                    compatible with Heard&apos;s features, including automatic
                    monthly statement uploads.
                    <br />
                    <br />
                    Some popular banks with Heard customers:
                    <ul className="list-disc pl-5 mt-2 space-y-1">
                      {[
                        {
                          name: 'Bluevine',
                          url: 'https://www.bluevine.com/partner/heard-checking',
                        },
                        {
                          name: 'Bank of America',
                          url: 'https://www.bankofamerica.com/smallbusiness/deposits/business-advantage-banking/',
                        },
                        {
                          name: 'BECU',
                          url: 'https://www.becu.org/business-banking/checking',
                        },
                        {
                          name: 'Chase',
                          url: 'https://www.chase.com/business/banking/checking',
                        },
                        {
                          name: 'TD Bank',
                          url: 'https://www.td.com/us/en/small-business/checking-accounts',
                        },
                        {
                          name: 'Wells Fargo',
                          url: 'https://www.wellsfargo.com/biz/checking/',
                        },
                      ].map((bank) => (
                        <li key={bank.name}>
                          <Link href={bank.url} newPage>
                            {bank.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                    <Link href="#" newPage className="block mt-4">
                      Connecting your bank account with Plaid →
                    </Link>
                  </Text>
                </Accordion.Content>
              </Accordion.Item>

              <Accordion.Item value="no-replacement">
                <Accordion.Trigger>
                  What if I don’t want to replace my account(s)?
                </Accordion.Trigger>
                <Accordion.Content>
                  <Text>
                    Our team will reach out to help you with your situation.
                    However, we strongly recommend replacing your accounts, as
                    Plaid-incompatible accounts significantly delay bookkeeping
                    and access to your reports.
                  </Text>
                  <Text>
                    We might not be able to support the account(s) if it
                    prevents us from providing consistent service.
                  </Text>
                </Accordion.Content>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </Card>

      <Button
        className="flex justify-center"
        variant="secondary"
        size="md"
        onClick={handleClick}
      >
        View Dashboard
      </Button>
    </div>
  )
}
